// 📟 Samsung 태블릿 데이터 (간소화된 구조)
import type { SamsungTabletSeriesData } from './deviceDataHelpers';

export const SAMSUNG_TABLET_DATA: SamsungTabletSeriesData[] = [
  {
    series: 'Galaxy Tab S',
    models: [
      // S9 시리즈
      { en: 'Galaxy Tab S9 Ultra', ko: '갤럭시 탭 S9 울트라', storages: ['256GB', '512GB', '1TB'], year: 2023, recommended: true },
      { en: 'Galaxy Tab S9+', ko: '갤럭시 탭 S9+', storages: ['256GB', '512GB'], year: 2023, recommended: true },
      { en: 'Galaxy Tab S9', ko: '갤럭시 탭 S9', storages: ['128GB', '256GB'], year: 2023, recommended: true },
      { en: 'Galaxy Tab S9 FE+', ko: '갤럭시 탭 S9 FE+', storages: ['128GB', '256GB'], year: 2023 },
      { en: 'Galaxy Tab S9 FE', ko: '갤럭시 탭 S9 FE', storages: ['128GB', '256GB'], year: 2023 },
      
      // S8 시리즈
      { en: 'Galaxy Tab S8 Ultra', ko: '갤럭시 탭 S8 울트라', storages: ['128GB', '256GB', '512GB'], year: 2022 },
      { en: 'Galaxy Tab S8+', ko: '갤럭시 탭 S8+', storages: ['128GB', '256GB'], year: 2022 },
      { en: 'Galaxy Tab S8', ko: '갤럭시 탭 S8', storages: ['128GB', '256GB'], year: 2022 },
      
      // S7 시리즈
      { en: 'Galaxy Tab S7 FE', ko: '갤럭시 탭 S7 FE', storages: ['64GB', '128GB', '256GB'], year: 2021 },
      { en: 'Galaxy Tab S7+', ko: '갤럭시 탭 S7+', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      { en: 'Galaxy Tab S7', ko: '갤럭시 탭 S7', storages: ['128GB', '256GB', '512GB'], year: 2020 },
      
      // S6 시리즈
      { en: 'Galaxy Tab S6 Lite', ko: '갤럭시 탭 S6 라이트', storages: ['64GB', '128GB'], year: 2024 },
      { en: 'Galaxy Tab S6 5G', ko: '갤럭시 탭 S6 5G', storages: ['128GB', '256GB'], year: 2020 },
      { en: 'Galaxy Tab S6', ko: '갤럭시 탭 S6', storages: ['128GB', '256GB'], year: 2019 },
      { en: 'Galaxy Tab S5e', ko: '갤럭시 탭 S5e', storages: ['64GB', '128GB'], year: 2019 },
      { en: 'Galaxy Tab S4', ko: '갤럭시 탭 S4', storages: ['64GB', '256GB'], year: 2018 },
      { en: 'Galaxy Tab S3', ko: '갤럭시 탭 S3', storages: ['32GB', '128GB'], year: 2017 },
      { en: 'Galaxy Tab S2 9.7', ko: '갤럭시 탭 S2 9.7', storages: ['32GB', '64GB'], year: 2015 },
      { en: 'Galaxy Tab S2 8.0', ko: '갤럭시 탭 S2 8.0', storages: ['32GB', '64GB'], year: 2015 },
      { en: 'Galaxy Tab S 10.5', ko: '갤럭시 탭 S 10.5', storages: ['16GB', '32GB'], year: 2014 },
      { en: 'Galaxy Tab S 8.4', ko: '갤럭시 탭 S 8.4', storages: ['16GB', '32GB'], year: 2014 }
    ]
  },
  {
    series: 'Galaxy Tab A',
    models: [
      { en: 'Galaxy Tab A9+', ko: '갤럭시 탭 A9+', storages: ['64GB', '128GB', '256GB'], year: 2023 },
      { en: 'Galaxy Tab A9', ko: '갤럭시 탭 A9', storages: ['64GB', '128GB'], year: 2023 },
      { en: 'Galaxy Tab A8 (10.5)', ko: '갤럭시 탭 A8 (10.5)', storages: ['32GB', '64GB', '128GB'], year: 2021 },
      { en: 'Galaxy Tab A7 (10.4)', ko: '갤럭시 탭 A7 (10.4)', storages: ['32GB', '64GB'], year: 2020 },
      { en: 'Galaxy Tab A7 Lite (8.7)', ko: '갤럭시 탭 A7 라이트 (8.7)', storages: ['32GB', '64GB'], year: 2021 },
      { en: 'Galaxy Tab A 10.1', ko: '갤럭시 탭 A 10.1', storages: ['32GB', '64GB', '128GB'], year: 2019 },
      { en: 'Galaxy Tab A 8.0', ko: '갤럭시 탭 A 8.0', storages: ['32GB', '64GB'], year: 2019 },
      { en: 'Galaxy Tab A 10.5', ko: '갤럭시 탭 A 10.5', storages: ['32GB', '64GB'], year: 2018 },
      { en: 'Galaxy Tab A 8.0 (S Pen)', ko: '갤럭시 탭 A 8.0 (S펜)', storages: ['32GB'], year: 2018 },
      { en: 'Galaxy Tab A 8.0', ko: '갤럭시 탭 A 8.0', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy Tab A 10.1', ko: '갤럭시 탭 A 10.1', storages: ['16GB', '32GB', '64GB'], year: 2016 },
      { en: 'Galaxy Tab A 7.0', ko: '갤럭시 탭 A 7.0', storages: ['8GB', '16GB'], year: 2016 },
      { en: 'Galaxy Tab A 9.7', ko: '갤럭시 탭 A 9.7', storages: ['16GB', '32GB'], year: 2015 },
      { en: 'Galaxy Tab A 8.0', ko: '갤럭시 탭 A 8.0', storages: ['16GB', '32GB'], year: 2015 }
    ]
  },
  {
    series: 'Galaxy Tab Active',
    models: [
      { en: 'Galaxy Tab Active5', ko: '갤럭시 탭 액티브5', storages: ['128GB', '256GB'], year: 2024 },
      { en: 'Galaxy Tab Active4 Pro', ko: '갤럭시 탭 액티브4 프로', storages: ['64GB', '128GB'], year: 2022 },
      { en: 'Galaxy Tab Active3', ko: '갤럭시 탭 액티브3', storages: ['64GB', '128GB'], year: 2020 },
      { en: 'Galaxy Tab Active Pro', ko: '갤럭시 탭 액티브 프로', storages: ['64GB', '128GB'], year: 2019 },
      { en: 'Galaxy Tab Active2', ko: '갤럭시 탭 액티브2', storages: ['16GB', '32GB'], year: 2017 },
      { en: 'Galaxy Tab Active', ko: '갤럭시 탭 액티브', storages: ['16GB'], year: 2014 }
    ]
  },
  {
    series: 'Galaxy Tab E',
    models: [
      { en: 'Galaxy Tab E 9.6', ko: '갤럭시 탭 E 9.6', storages: ['8GB', '16GB'], year: 2015 }
    ]
  },
  {
    series: 'Galaxy Tab 4',
    models: [
      { en: 'Galaxy Tab 4 10.1', ko: '갤럭시 탭 4 10.1', storages: ['16GB', '32GB'], year: 2014 },
      { en: 'Galaxy Tab 4 8.0', ko: '갤럭시 탭 4 8.0', storages: ['16GB'], year: 2014 },
      { en: 'Galaxy Tab 4 7.0', ko: '갤럭시 탭 4 7.0', storages: ['8GB', '16GB'], year: 2014 }
    ]
  },
  {
    series: 'Galaxy Tab 3',
    models: [
      { en: 'Galaxy Tab 3 10.1', ko: '갤럭시 탭 3 10.1', storages: ['16GB', '32GB'], year: 2013 },
      { en: 'Galaxy Tab 3 8.0', ko: '갤럭시 탭 3 8.0', storages: ['16GB', '32GB'], year: 2013 },
      { en: 'Galaxy Tab 3 7.0', ko: '갤럭시 탭 3 7.0', storages: ['8GB', '16GB'], year: 2013 }
    ]
  },
  {
    series: 'Galaxy Tab 2',
    models: [
      { en: 'Galaxy Tab 2 10.1', ko: '갤럭시 탭 2 10.1', storages: ['16GB', '32GB'], year: 2012 },
      { en: 'Galaxy Tab 2 7.0', ko: '갤럭시 탭 2 7.0', storages: ['8GB', '16GB', '32GB'], year: 2012 }
    ]
  },
  {
    series: 'Galaxy Tab',
    models: [
      { en: 'Galaxy Tab 10.1', ko: '갤럭시 탭 10.1', storages: ['16GB', '32GB', '64GB'], year: 2011 },
      { en: 'Galaxy Tab 8.9', ko: '갤럭시 탭 8.9', storages: ['16GB', '32GB', '64GB'], year: 2011 },
      { en: 'Galaxy Tab 7.7', ko: '갤럭시 탭 7.7', storages: ['16GB', '32GB', '64GB'], year: 2011 },
      { en: 'Galaxy Tab 7.0 Plus', ko: '갤럭시 탭 7.0 플러스', storages: ['16GB', '32GB', '64GB'], year: 2011 },
      { en: 'Galaxy Tab 7.0', ko: '갤럭시 탭 7.0', storages: ['16GB', '32GB'], year: 2010 }
    ]
  },
  {
    series: 'Galaxy Tab Pro',
    models: [
      { en: 'Galaxy Tab Pro 12.2', ko: '갤럭시 탭 프로 12.2', storages: ['32GB', '64GB'], year: 2014 },
      { en: 'Galaxy Tab Pro 10.1', ko: '갤럭시 탭 프로 10.1', storages: ['16GB', '32GB'], year: 2014 },
      { en: 'Galaxy Tab Pro 8.4', ko: '갤럭시 탭 프로 8.4', storages: ['16GB', '32GB'], year: 2014 }
    ]
  }
];
